// @flow

const ValueUtil = {};

function isObject(obj) {
  return obj === Object(obj);
}

let isFunction = function(obj) {
  return toString.call(obj) === '[object Function]';
};
// eslint-disable-next-line no-constant-condition
if (typeof /./ !== 'function') {
  isFunction = function(obj) {
    return typeof obj === 'function';
  };
}

/**
 * Copy of jQuery extend method
 * @param {boolean} If true, the merge becomes recursive (aka. deep copy).
 * @param {Object} The object to extend. ...
 * @param {Object} An object containing additional properties to merge in. Can specify object1...objectN
 * @return {*}
 */
ValueUtil.deepExtend = function(...args: any) {
  let options,
    name,
    src,
    copy,
    copyIsArray,
    clone,
    target = args[0] || {},
    i = 1,
    deep = false;

  const length = arguments.length;

  // Handle a deep copy situation
  if (typeof target === 'boolean') {
    deep = target;

    // Skip the boolean and the target
    target = args[i] || {};
    i += 1;
  }

  // Handle case when target is a string or something (possible in deep copy)
  if (typeof target !== 'object' && !isFunction(target)) {
    target = {};
  }

  for (; i < length; i += 1) {
    options = args[i];
    // Only deal with non-null/undefined values
    if (options !== null) {
      // Extend the base object
      for (name in options) {
        src = target[name];
        copy = options[name];

        // Prevent never-ending loop
        if (target === copy) {
          /* eslint no-continue:0 */
          continue;
        }

        // Recurse if we're merging plain objects or arrays
        copyIsArray = Array.isArray(copy);
        if (deep && copy && (this.isPlainObject(copy) || copyIsArray)) {
          if (copyIsArray) {
            copyIsArray = false;
            clone = src && Array.isArray(src) ? src : [];
          } else {
            clone = src && this.isPlainObject(src) ? src : {};
          }

          // Never move original objects, clone them
          target[name] = this.deepExtend(deep, clone, copy);

          // Don't bring in undefined values
        } else if (copy !== undefined) {
          target[name] = copy;
        }
      }
    }
  }

  // Return the modified object
  return target;
};

/**
 * Tests whether the value passed in is a plain object.
 * @param {*} val
 * @return {boolean}
 */
ValueUtil.isPlainObject = function(val /*: * */) {
  if (
    !val ||
    typeof val !== 'object' ||
    Object.prototype.toString.call(val) !== '[object Object]' ||
    val.nodeType ||
    val.window
  ) {
    return false;
  }

  if (val.constructor && !{}.hasOwnProperty.call(val.constructor.prototype, 'isPrototypeOf')) {
    return false;
  }

  return true;
};

/**
 * @param {*} val
 * @return {*}
 */
ValueUtil.deepCopy = function<T>(val: T): T {
  if (Array.isArray(val)) {
    return this.deepExtend(true, [], val);
  } else if (isObject(val)) {
    return this.deepExtend(true, {}, val);
  }
  return val;
};

export default ValueUtil;
